import React from "react";
import clsx from "clsx";
import { Card, CardContent, Typography, useTheme } from "@material-ui/core";

import { Theme } from "../.themes";
import PersonaAvatar from "./PersonaAvatar";
import { BaseCoverageCardProps, coverageCardUseStyles } from "./CoverageCard";

type AvatarCoverageProps = BaseCoverageCardProps & {
  showAvatar: boolean;
};

const AvatarCoverageCard: React.FC<AvatarCoverageProps> = (props: AvatarCoverageProps) => {
  const theme: Theme = useTheme();
  const classes = coverageCardUseStyles(theme);

  const descriptionPopupSize = {
    width: `100%`,
  };

  return (
    <>
      <Typography variant='h2'>Välj försäkring</Typography>
      <Card className={clsx(classes.CoverageDescriptionCard)} style={descriptionPopupSize} variant='outlined'>
        <CardContent className={classes.RecommendationCardContent}>
          {props.showAvatar && <PersonaAvatar recommendedTitle={props.recommendedTitle} currentCoverage={props.currentCoverage} />}
          <Typography ref={props.cardRef} className={classes.DescriptionText}>
            {props.currentCoverage?.Description}
          </Typography>
        </CardContent>
        <span className={classes.CoverageDescriptionCardArrow} style={props.arrowStyle}></span>
      </Card>
    </>
  );
};

export default AvatarCoverageCard;
